import { Button } from 'react-bootstrap'

export default function ClearButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button
                type='button'
                variant='light'
                size='sm'
                className='border close_btn'
                onClick={onClick}
            >
                {button_name}
            </Button>
        </>
    )
}